<section class="container-fluid " id="plans">
    <div class="plans">
        <div class="container">
            <div class="row mobile-hide">
                <div class="col-md-4 col-sm-12 d-flex flex-row justify-content-between" *ngFor="let data of items">
                    <div class="plans-item"
                         [ngClass]="{'bestValue': data.isBestValue}">
                        <div class="header">
                            <h2>{{data.title}}</h2>
                            <p>
                                {{data.header_description}}
<!--                                <lib-dast-renderer-->
<!--                                        *ngIf="data?.description?.value?.document"-->
<!--                                        [dastNode]="data.description.value.document"></lib-dast-renderer>-->
                            </p>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row mobile-hide">
                <div class="col-md-4 col-sm-12 plans-item pr-0" *ngFor="let data of items; let i=index">
                    <div class="body p-0">
                        <div *ngIf="data.isBestValue" class="best_value-block mt-0 mobile-hide">
                            <span>Найкраща ціна</span>
                            <img src="assets/img/bookmark-icon.png" alt="bookmark-icon"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12 plans-item" *ngFor="let data of items">
                    <div class="mobile-show "
                         [ngClass]="{'bestValue': data.isBestValue}">
                        <div class="header">
                            <h2>{{data.title}}</h2>
                            <p>
                                <lib-dast-renderer
                                        *ngIf="data?.description?.value?.document"
                                        [dastNode]="data.description.value.document"></lib-dast-renderer>
                            </p>
                        </div>
                        <div *ngIf="data.isBestValue" class="best_value-block mt-0 ">
                            <span>найкраща ціна</span>
                            <img src="assets/img/bookmark-icon.png" alt="bookmark-icon"/>
                        </div>
                    </div>
                    <div class="body">
                        <ul>
                            <li *ngFor="let item of data.recommendations">
                                <span>{{item}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="mobile-show">
                        <div class="flex-1">
                            <div class="price-block">
                                <span class="total" *ngIf="data?.total">${{data?.total}}</span>
                                <span><small class="small"><sup class="sup">₴</sup></small>{{data.value}}</span>
                            </div>
                        </div>
                        <div class="payment row ">
                            <!--              <div class="col-4 justify-content-start ">-->
                            <!--&lt;!&ndash;                <img src="assets/img/paypal.png" alt="paypal-icon"/>&ndash;&gt;-->
                            <!--              </div>-->
                            <div class="col justify-content-end d-flex">
                                <button [disabled]="!data.id" class="" (click)="onPay(data.subscription, data)">
                                    <span *ngIf="!data.id" class="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                    <span>{{data.btnText}}</span>
                                    <app-i-arrow></app-i-arrow>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mobile-hide">
                <div class="col-md-4 col-sm-12 plans-item" *ngFor="let data of items; let i=index">
                    <div class="body" [ngClass]="{'pr-0': i===1}">
                        <div class="price-block">
                            <span class="total" *ngIf="data?.total">₴{{data?.total}}</span>
                            <span><small><sup>₴</sup></small>{{data.value}}</span>
                        </div>

                    </div>
                    <div class="payment row ">
                        <!--            <div class="col-1 col-lg-4 justify-content-end d-flex">-->
                        <!--&lt;!&ndash;              <img src="assets/img/paypal.png" alt="paypal-icon"/>&ndash;&gt;-->
                        <!--            </div>-->
                        <div class="col justify-content-end d-flex">
                            <button [disabled]="!data.id" class="" (click)="onPay(data.subscription, data)">
                                <span *ngIf="!data.id" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                                <span *ngIf="data.id">{{data.btnText}}</span>
                                <app-i-arrow *ngIf="data.id"></app-i-arrow>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<lib-preloader [loading]="loading"></lib-preloader>
